import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduce, capitalize } from 'lodash';
import { Modal, Button } from 'react-bootstrap';
import NumberDisplay from '../../../../components/number-display';

class ApiUsageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.close = this.close.bind(this);
  }

  close() {
    this.props.onModalClose();
  }

  render() {
    const { organization } = this.props;
    const title = `Api Usage for ${organization.display_name}`;

    let total = 0;

    const rows = reduce(organization.api_usages, (items, v, k) => {
      const val = Math.max(v, 0);
      total += val;
      items.push((
        <tr key={k}>
          <td>{capitalize(k.replaceAll('_', ' '))}</td>
          <td className="text-right">
            <NumberDisplay value={val} precision={0} />
          </td>
        </tr>
      ));
      return items;
    }, []);

    return (
      <Modal show={this.props.show} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {rows.length > 0 &&
              <table className="table table-condensed table-striped">
                <thead>
                  <tr>
                    <th>Sync Task</th>
                    <th className="text-right">Usage</th>
                  </tr>
                </thead>
                <tbody>{rows}</tbody>
                <tfoot>
                  <tr>
                    <th>Total</th>
                    <th className="text-right"><NumberDisplay value={total} precision={0} /></th>
                  </tr>
                </tfoot>
              </table>
            }
            {rows.length === 0 && <div className="alert alert-warning">No usage reports found.</div>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }

}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

ApiUsageModal.propTypes = {
  organization: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
    api_usages: PropTypes.shape({}),
  }).isRequired,
  onModalClose: PropTypes.func,
};
ApiUsageModal.defaultProps = {
  onModalClose: () => {},
};
ApiUsageModal.contextTypes = {
};


export default connect(mapStateToProps)(ApiUsageModal);
